// Phase 6 — Partners & commissions vocabulary + French labels + badge styles.
import { formatMoney } from "@/lib/format";

export const PARTNER_TYPES = {
  HOTEL: "Hôtel", RIAD: "Riad", AGENCY: "Agence", CONCIERGE: "Conciergerie",
  GUIDE_PARTNER: "Guide partenaire", TOUR_OPERATOR: "Tour-opérateur",
  INFLUENCER: "Influenceur", OTHER: "Autre",
};

export const PARTNER_STATUS = {
  ACTIVE: { label: "Actif", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  INACTIVE: { label: "Inactif", cls: "bg-slate-100 text-slate-500 border-slate-300" },
};

export const COMMISSION_TYPES = { PERCENTAGE: "Pourcentage", FIXED_AMOUNT: "Montant fixe" };

export const COMMISSION_STATUS = {
  PENDING: { label: "Projetée", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  DUE: { label: "À régler", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  PAID: { label: "Réglée", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  CANCELLED: { label: "Annulée", cls: "bg-slate-100 text-slate-500 border-slate-300" },
};

export const PARTNER_TYPE_LIST = Object.keys(PARTNER_TYPES);

export const PARTNER_ACTION_LABELS = {
  "partner.created": "Partenaire créé",
  "partner.updated": "Partenaire modifié",
  "partner.activated": "Partenaire réactivé",
  "partner.deactivated": "Partenaire désactivé",
  "partner.settlement_created": "Règlement enregistré",
};

// Human-readable commission rule. FIXED_AMOUNT value is stored in minor units (cents).
export function commissionRuleText(type, value, currency = "MAD") {
  if (!type || value == null) return "Aucune commission";
  if (type === "PERCENTAGE") return `${value} %`;
  return `${formatMoney(value, currency)} / réservation`;
}
